module.exports = __webpack_public_path__ + "img/bst_ch_khazrak_0.5ab6255c.png";